import { trackingEvent } from '@notino/web-tracking';

import { dispatchEcommerceMessage } from '@services/messagingService';

import { EcommerceSectionNamespace } from '../../model';

export const trackOnStickyVoucherAnchorClick = (timing: number) => {
  dispatchEcommerceMessage(
    trackingEvent({
      event: EcommerceSectionNamespace.EEcommerceEvent.ELEMENT_CLICK,
      element: {
        name: EcommerceSectionNamespace.EEcommerceName.LINK_TO_COUPON,
        type: EcommerceSectionNamespace.EEcommerceType.CHECKOUT_CART,
        interaction: EcommerceSectionNamespace.EEcommerceInteraction.LINK_CHECKOUT_STICKY,
        timing,
      },
      _clear: true,
    }),
  );
};
